/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shipped: NonNullable<unknown>, total: NonNullable<unknown> }} Fulfillment_Units_ShippedInputs */

const en_fulfillment_units_shipped = /** @type {(inputs: Fulfillment_Units_ShippedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.shipped} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{shipped} of {total}" |
*
* @param {Fulfillment_Units_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_units_shipped = /** @type {((inputs: Fulfillment_Units_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Units_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_units_shipped(inputs)
});